"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ribbon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Style
var Ribbon = function Ribbon(_ref) {
  var type = _ref.type,
      className = _ref.className,
      stickerStyle = _ref.stickerStyle,
      style = _ref.style,
      label = _ref.label;
  // Ribbon Modifier
  var typeClassname = '';

  switch (type) {
    case 'left-top':
      typeClassname = 'shpmtc-ribbon--left-top';
      break;

    case 'left-bottom':
      typeClassname = 'shpmtc-ribbon--left-bottom';
      break;

    case 'right-top':
      typeClassname = 'shpmtc-ribbon--right-top';
      break;

    case 'right-bottom':
      typeClassname = 'shpmtc-ribbon--right-bottom';
      break;

    default:
      typeClassname = 'shpmtc-ribbon--left-top';
      break;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "shpmtc-ribbon ".concat(typeClassname, " ").concat(className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "shpmtc-ribbon__sticker",
    style: stickerStyle
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sticker-text"
  }, label)));
}; // Prop Types


exports.Ribbon = Ribbon;
Ribbon.defaultProps = {
  style: null,
  stickerStyle: null,
  className: '',
  type: null,
  label: null
};
Ribbon.propTypes = {
  style: _propTypes.default.instanceOf(Object),
  stickerStyle: _propTypes.default.instanceOf(Object),
  className: _propTypes.default.string,
  type: _propTypes.default.string,
  label: _propTypes.default.string
};